// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// DEBUG MODE - Solo para desarrollo en localhost
//window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

// Tus credenciales (las que ya tienes)
const firebaseConfig = {
  apiKey: "AIzaSyD3vcsULgCmAN06t4-IvFMBGjFa0rbDGLg",
  authDomain: "app-newparalellum.firebaseapp.com",
  projectId: "app-newparalellum",
  storageBucket: "app-newparalellum.firebasestorage.app",
  messagingSenderId: "499602105666",
  appId: "1:499602105666:web:3a61517c542c19658654db"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar App Check - DESHABILITADO TEMPORALMENTE
// const appCheck = initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider('6LfMi-UrAAAAADmerJkFBC2JLyit3c0Re1h1jlce'),
//   isTokenAutoRefreshEnabled: true
// });

// Servicios que vamos a usar
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Nombres de las colecciones (como tablas) en la base de datos
export const COLLECTIONS = {
  USERS: 'usuarios',
  COMPANIES: 'empresas',
  WAREHOUSES: 'bodegas',
  PRODUCTS: 'productos',
  ORDERS: 'pedidos',
  CUSTOMERS: 'clientes',
  ACTIVITY_LOG: 'registro_actividad',
};

export default app;